import { BaseModel } from '../../../../../../core/_base/crud';

    export class KeHoachSanXuat extends BaseModel {
       
        public static namesOfDays = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];
        public static CATEGORY = "KHSX";
        
        DatHangId: number
        DatHangCtId: number
        SoPhieuDatHang: string
        Type: number
        HanghoaTPId: number
        MaHangTP: string
        TenHangTP: string
        DvtTP: number
        TenDVTTP: string
        HanghoaNPLId: number
        MaHangNPL: string
        TenHangNPL: string
        DvtNPL: number
        TenDVTNPL: string
        KhachhangId: number
        TenKhachHang: string
        IdNCC: number
        MaNCC: string
        TenNCC: string
        SoLuongDat: number
        SoLuongGiao: number
        GioVeTu: string
        strNgayTu: string
        GioVeDen: string
        strNgayDen: string
        IdGiaiDoan: number
        TenGiaiDoan: string
        SoLuongTonKho: number
        SoLuongDaSX: number
        Mua_PhieuDeNghi_Id: number
        HieuSuatBTPGdDau: number
        isCreateKHSX: boolean
        SoLuongTienDoKH: number
        SoLuongTienDoSX: number
        listElement: KeHoachSanXuat[]
        listKHXN: ThongTinKeHoachXacNhanPO[]
        RD_BoM_Id: number;

        //extend fields
        currentSelectedGiaiDoan: number
        SoLuong_Goc: number
        DVT_Goc: number
        TenDVT_Goc: string
        KhoiLuongDauVao: number;
        IdHHSX : number
        _listTPBTP: any[]
        IdStepNPL: number
        _nplData : string
        _listIdNPL: any[]

        clear(){
            this.DatHangId = 0;
            this.DatHangCtId = 0;
            this.SoPhieuDatHang = '';
            this.Type = 0;
            this.HanghoaTPId = 0;
            this.MaHangTP= '';
            this.TenHangTP= '';
            this.DvtTP = 0;
            this.TenDVTTP= '';
            this.HanghoaNPLId = 0;
            this.MaHangNPL= '';
            this.TenHangNPL= '';
            this.DvtNPL = 0;
            this.TenDVTNPL= '';
            this.KhachhangId = 0;
            this.TenKhachHang= '';
            this.IdNCC = 0;
            this.MaNCC= '';
            this.TenNCC= '';
            this.SoLuongDat = 0;
            this.SoLuongGiao = 0;
            this.GioVeTu= '';
            this.strNgayTu = '';
            this.GioVeDen= '';
            this.strNgayDen = '';
            this.IdGiaiDoan = 0;
            this.TenGiaiDoan= '';
            this.SoLuongTonKho = 0;
            this.SoLuongDaSX = 0;
            this.Mua_PhieuDeNghi_Id = 0;
            this.HieuSuatBTPGdDau = 0;
            this.isCreateKHSX = false;
            this.SoLuongTienDoKH = 0;
            this.SoLuongTienDoSX = 0;
            this.listElement = [];
            this.listKHXN = [];
            this.currentSelectedGiaiDoan = 0;
            this.SoLuong_Goc = 0;
            this.DVT_Goc = 0;
            this.TenDVT_Goc = '';
            this.RD_BoM_Id = 0;
            this.KhoiLuongDauVao = 0;
            this.IdHHSX = 0;
            this._listTPBTP = [];
            this.IdStepNPL = 0;
            this._nplData = '';
            this._listIdNPL = [];
        }
        
        copy(item:KeHoachSanXuat){
            this.DatHangId = item.DatHangId;
            this.DatHangCtId = item.DatHangCtId;
            this.SoPhieuDatHang = item.SoPhieuDatHang;
            this.Type = item.Type;
            this.HanghoaTPId = item.HanghoaTPId;
            this.MaHangTP= item.MaHangTP;
            this.TenHangTP= item.TenHangTP;
            this.DvtTP = item.DvtTP;
            this.TenDVTTP= item.TenDVTTP;
            this.HanghoaNPLId = item.HanghoaNPLId;
            this.MaHangNPL= item.MaHangNPL;
            this.TenHangNPL= item.TenHangNPL;
            this.DvtNPL = item.DvtNPL;
            this.TenDVTNPL= item.TenDVTNPL;
            this.KhachhangId = item.KhachhangId;
            this.TenKhachHang= item.TenKhachHang;
            this.IdNCC = item.IdNCC;
            this.MaNCC= item.MaNCC;
            this.TenNCC= item.TenNCC;
            this.SoLuongDat = item.SoLuongDat;
            this.SoLuongGiao = item.SoLuongGiao;
            this.GioVeTu= item.GioVeTu;
            this.strNgayTu = item.strNgayTu;
            this.strNgayDen = item.strNgayDen;
            this.GioVeDen= item.GioVeDen;
            this.IdGiaiDoan = item.IdGiaiDoan;
            this.TenGiaiDoan= item.TenGiaiDoan;
            this.SoLuongTonKho = item.SoLuongTonKho;
            this.SoLuongDaSX = item.SoLuongDaSX;
            this.Mua_PhieuDeNghi_Id = item.Mua_PhieuDeNghi_Id;
            this.HieuSuatBTPGdDau = item.HieuSuatBTPGdDau;
            this.isCreateKHSX = item.isCreateKHSX;
            this.SoLuongTienDoKH = item.SoLuongTienDoKH;
            this.SoLuongTienDoSX = item.SoLuongTienDoSX;
            this.listElement = item.listElement;
            this.SoLuong_Goc = item.SoLuong_Goc;
            this.DVT_Goc = item.DVT_Goc;
            this.TenDVT_Goc = item.TenDVT_Goc;
            this.listKHXN = item.listKHXN;
            this.RD_BoM_Id = item.RD_BoM_Id;
            this.KhoiLuongDauVao = item.KhoiLuongDauVao;
            this.IdHHSX = item.IdHHSX;
            this._listTPBTP = item._listTPBTP;
            this.IdStepNPL = item.IdStepNPL;
            this._nplData = item._nplData;
            this._listIdNPL = item._listIdNPL;
        }
    }

    export class KeHoachSanXuatTuan extends BaseModel{
        Id: number
        TuNgay: string
        DenNgay: string
        TrangThai: string
        NguoiTao: number
        NgayTao: string
        GhiChu: string
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        isDuyet: boolean
        LyDoDuyet: string
        KhuVucSanXuat_Id: number

        listKeHoachSanXuatTuanLsThaoTac: KeHoachSanXuatTuanLsThaoTac[]

        clear(){
            this.Id = 0;
            this.TuNgay = '';
            this.DenNgay = '';
            this.TrangThai = '';
            this.NguoiTao = 0;
            this.NgayTao = '';
            this.GhiChu = '';
            this.IsEnable_Duyet = false;
            this.IsVisible_Duyet = false;
            this.isDuyet = false;
            this.LyDoDuyet = '';
            this.KhuVucSanXuat_Id = 0;
            this.listKeHoachSanXuatTuanLsThaoTac = [];
        }
    
        copy(item: KeHoachSanXuatTuan){
            this.Id = item.Id;
            this.TuNgay = item.TuNgay;
            this.DenNgay = item.DenNgay;
            this.TrangThai = item.TrangThai;
            this.NguoiTao = item.NguoiTao;
            this.NgayTao = item.NgayTao;
            this.GhiChu = item.GhiChu;
            this.IsEnable_Duyet = item.IsEnable_Duyet;
            this.IsVisible_Duyet = item.IsVisible_Duyet;
            this.isDuyet = item.isDuyet;
            this.LyDoDuyet = item.LyDoDuyet;
            this.KhuVucSanXuat_Id = item.KhuVucSanXuat_Id;
            this.listKeHoachSanXuatTuanLsThaoTac = item.listKeHoachSanXuatTuanLsThaoTac
        }
    }

    export class KeHoachSanXuatTuanLsThaoTac extends BaseModel{
        Id: number;
        KeHoachTuanId: number;
        NguoiThaoTac: number;
        TenNguoiThaoTac: string;
        NgayThaoTac: string;
        LoaiThaoTac: string;
        NoiDung: string;
        GhiChu: string;

        clear(){
            this.Id = 0;
            this.KeHoachTuanId = 0;
            this.NguoiThaoTac = 0;
            this.TenNguoiThaoTac = '';
            this.NgayThaoTac = '';
            this.LoaiThaoTac = '';
            this.NoiDung = '';
            this.GhiChu = '';
        }

        copy(item: KeHoachSanXuatTuanLsThaoTac){
            this.Id = item.Id;
            this.KeHoachTuanId = item.KeHoachTuanId;
            this.NguoiThaoTac = item.NguoiThaoTac;
            this.TenNguoiThaoTac = item.TenNguoiThaoTac;
            this.NgayThaoTac = item.NgayThaoTac;
            this.LoaiThaoTac = item.LoaiThaoTac;
            this.NoiDung = item.NoiDung;
            this.GhiChu = item.GhiChu;
        }
    }

    export class KhKeHoachSanXuatInteraction extends BaseModel{

        static category_path = "KHSX";
        static optionsTinhTrang:any = [
            {
                id: 1,
                name: 'Đang soạn thảo',
                value: 'KHSX_DANGSOANTHAO',
            },
            {
                id: 2,
                name: 'Chờ duyệt',
                value: 'KHSX_CHODUYET',
            },
            {
                id: 3,
                name: 'Không duyệt',
                value: 'KHSX_KHONGDUYET',
            },
            {
                id: 4,
                name: 'Chờ thực hiện',
                value: 'KHSX_CHOTHUCHIEN',
            },
            {
                id: 5,
                name: 'Đã thực hiện',
                value: 'KHSX_DATHUCHIEN',
            },
            {
                id: 6,
                name: 'Đã xóa',
                value: 'KHSX_DAHUY',
            },
            {
                id: 7,
                name: 'Chờ xem xét',
                value: 'KHSX_CHOXEMXET',
            },
            {
                id: 8,
                name: 'Không xem xét',
                value: 'KHSX_KHONGXEMXET',
            },
            {
                id: 9,
                name: 'Chờ MH xác nhận',
                value: 'KHSX_CHOMHXACNHAN',
            },
            {
                id: 10,
                name: 'MH không đáp ứng',
                value: 'KHSX_MHKHONGDAPUNG',
            },
            {
                id: 11,
                name: 'MH có thể đáp ứng',
                value: 'KHSX_MHDAPUNG',
            },
            {
                id: 12,
                name: 'Chờ duyệt hủy',
                value: 'KHSX_CHODUYETHUY',
            },
            {
                id: 13,
                name: 'Đã hủy',
                value: 'KHSX_DADUYETHUY',
            },
        ];

        Id: number
        KdDatHangCtId: number
        DatHangId: number
        DatHangCtId: number
        SoPhieuDatHang: string
        Type: number
        HanghoaTPId: number
        MaHangTP: string
        TenHangTP: string
        DvtTP: number
        TenDVTTP: string
        KhachhangId: number
        TenKhachHang: string
        SoLuongTonKho: number
        SoLuongSanXuat: number
        SoLuongTP: number
        Dvt: number
        NgaySanXuat: string
        RdQtsxGiaiDoanId: number
        TenGiaiDoan: string
        TrangThai: string
        TenTrangThai: string
        NgayTao: string
        NguoiTao: number
        TypeChoose: number
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        isDuyet: boolean
        LyDoDuyet: string
        NSTB: number
        CNHC: number
        CNTC: number
        GhiChu: string
        KhuVucSanXuat_Id: number
        KeHoachTuan_Id: number
        TuNgay: string
        DenNgay: string
        TrangThaiXacNhanDNMH: number
        KLDauVaoBaoCao: number
        MaHangTPCaseHuyDuyet: string
        TenHangTPCaseHuyDuyet: string
        IsEnable_DuyetCaseHuyDuyet: boolean
        IsVisible_DuyetCaseHuyDuyet: boolean
        listKHSXNPL: KhKeHoachSanXuatDuKienNhapXuatInteraction[]
        listThongTinThietBi : ThongTinThietBi[]
        RD_BoM_Id: number
        MaBOM: string
        KhoiLuongDauVao: number;
        _listKVSX: any[]

        clear(){
            this.Id = 0;
            this.KdDatHangCtId = 0;
            this.DatHangId = 0;
            this.DatHangCtId = 0;
            this.SoPhieuDatHang = '';
            this.Type = 0;
            this.HanghoaTPId = 0;
            this.MaHangTP= '';
            this.TenHangTP = '';
            this.DvtTP = 0;
            this.TenDVTTP = '';
            this.KhachhangId = 0;
            this.TenKhachHang = '';
            this.SoLuongTonKho = 0;
            this.SoLuongSanXuat = 0;
            this.SoLuongTP = 0;
            this.Dvt = 0;
            this.NgaySanXuat = '';
            this.RdQtsxGiaiDoanId = 0;
            this.TenGiaiDoan = '';
            this.TrangThai = '';
            this.TenTrangThai = '';
            this.NgayTao = '';
            this.NguoiTao = 0;
            this.TypeChoose = -1;
            this.IsEnable_Duyet = false;
            this.IsVisible_Duyet = false;
            this.isDuyet = false;
            this.LyDoDuyet = '';
            this.NSTB = 0;
            this.CNHC = 0;
            this.CNTC = 0;
            this.GhiChu = '';
            this.KhuVucSanXuat_Id = 0;
            this.KeHoachTuan_Id = 0;
            this.TuNgay = '';
            this.DenNgay = '';
            this.TrangThaiXacNhanDNMH = -1;
            this.KLDauVaoBaoCao = 0;
            this.MaHangTPCaseHuyDuyet = '';
            this.TenHangTPCaseHuyDuyet = '';
            this.IsEnable_DuyetCaseHuyDuyet = false;
            this.IsVisible_DuyetCaseHuyDuyet = false;
            this.listKHSXNPL = [];
            this.listThongTinThietBi = [];
            this.RD_BoM_Id = 0;
            this.MaBOM = '';
            this.KhoiLuongDauVao = 0;
            this._listKVSX = [];
        }
        copy(item: KhKeHoachSanXuatInteraction){
            this.Id = item.Id;
            this.KdDatHangCtId = item.KdDatHangCtId;
            this.DatHangId = item.DatHangId;
            this.DatHangCtId = item.DatHangCtId;
            this.SoPhieuDatHang = item.SoPhieuDatHang;
            this.Type = item.Type;
            this.HanghoaTPId = item.HanghoaTPId;
            this.MaHangTP= item.MaHangTP;
            this.TenHangTP = item.TenHangTP;
            this.DvtTP = item.DvtTP;
            this.TenDVTTP = item.TenDVTTP;
            this.KhachhangId = item.KhachhangId;
            this.TenKhachHang = item.TenKhachHang;
            this.SoLuongTonKho = item.SoLuongTonKho;
            this.SoLuongTP = item.SoLuongTP;
            this.SoLuongSanXuat = item.SoLuongSanXuat;
            this.Dvt = item.Dvt;
            this.NgaySanXuat = item.NgaySanXuat;
            this.RdQtsxGiaiDoanId = item.RdQtsxGiaiDoanId;
            this.TenGiaiDoan = item.TenGiaiDoan;
            this.TrangThai = item.TrangThai;
            this.TenTrangThai = item.TenTrangThai;
            this.NgayTao = item.NgayTao;
            this.NguoiTao = item.NguoiTao;
            this.TypeChoose = item.TypeChoose;
            this.IsEnable_Duyet = item.IsEnable_Duyet;
            this.IsVisible_Duyet = item.IsVisible_Duyet;
            this.isDuyet = item.isDuyet;
            this.LyDoDuyet = item.LyDoDuyet;
            this.NSTB = item.NSTB;
            this.CNHC = item.CNHC;
            this.CNTC = item.CNTC;
            this.GhiChu = item.GhiChu;
            this.KhuVucSanXuat_Id = item.KhuVucSanXuat_Id;
            this.KeHoachTuan_Id = item.KeHoachTuan_Id;
            this.TuNgay = item.TuNgay;
            this.DenNgay = item.DenNgay;
            this.TrangThaiXacNhanDNMH = item.TrangThaiXacNhanDNMH;
            this.KLDauVaoBaoCao = item.KLDauVaoBaoCao;
            this.MaHangTPCaseHuyDuyet = item.MaHangTPCaseHuyDuyet;
            this.TenHangTPCaseHuyDuyet = item.TenHangTPCaseHuyDuyet;
            this.IsEnable_DuyetCaseHuyDuyet = item.IsEnable_DuyetCaseHuyDuyet;
            this.IsVisible_DuyetCaseHuyDuyet = item.IsVisible_DuyetCaseHuyDuyet;
            this.listKHSXNPL = item.listKHSXNPL;
            this.listThongTinThietBi = item.listThongTinThietBi;
            this.RD_BoM_Id = item.RD_BoM_Id;
            this.MaBOM = item.MaBOM;
            this.KhoiLuongDauVao = item.KhoiLuongDauVao;
            this._listKVSX = item._listKVSX;
        }
    }
    
    export class KhKeHoachSanXuatDuKienNhapXuatInteraction extends BaseModel{
        Id: number
        KhKeHoachSanXuatId: number
        HangHoaId: number
        MaHangNPL: string
        TenHangNPL: string
        Dvt: number
        TenDVTNPL: string
        SoLuongTonKho: number
        SoLuongTonKhoChuaKT: number
        SoLuongDeNghiMua: number
        DuKienNhap: number
        DuKienXuat: number
        Nstb: number
        Cnhc: number
        Cntc: number

        HanghoaTPId: number
        DatHangId: number
        DatHangCtId: number
        RdQtsxGiaiDoanId: number
        NgaySanXuat: string
        FlagHead: boolean
        FlagPassKhan: boolean
        FlagBTP: boolean
        FlagNPL: boolean
        messageBTP : string

        clear(){
            this.Id = 0;
            this.KhKeHoachSanXuatId = 0;
            this.HangHoaId = 0;
            this.MaHangNPL = '';
            this.TenHangNPL = '';
            this.Dvt = 0;
            this.TenDVTNPL = '';
            this.SoLuongTonKho = 0;
            this.SoLuongTonKhoChuaKT = 0;
            this.SoLuongDeNghiMua = 0;
            this.DuKienNhap = 0;
            this.DuKienXuat = 0;
            this.Nstb = 0;
            this.Cnhc = 0;
            this.Cntc = 0;

            this.HanghoaTPId = 0;
            this.DatHangId = 0;
            this.DatHangCtId = 0;
            this.RdQtsxGiaiDoanId = 0;
            this.NgaySanXuat = '';
            this.FlagHead = false;
            this.FlagPassKhan = false;
            this.FlagBTP = false;
            this.FlagNPL = false;
            this.messageBTP = '';
        }

        copy(item: KhKeHoachSanXuatDuKienNhapXuatInteraction){
            this.Id = item.Id;
            this.KhKeHoachSanXuatId = item.KhKeHoachSanXuatId;
            this.HangHoaId = item.HangHoaId;
            this.MaHangNPL = item.MaHangNPL;
            this.TenHangNPL = item.TenHangNPL;
            this.Dvt = item.Dvt;
            this.TenDVTNPL = item.TenDVTNPL;
            this.SoLuongTonKho = item.SoLuongTonKho;
            this.SoLuongTonKhoChuaKT = item.SoLuongTonKhoChuaKT;
            this.SoLuongDeNghiMua = item.SoLuongDeNghiMua;
            this.DuKienNhap = item.DuKienNhap;
            this.DuKienXuat = item.DuKienXuat;
            this.Nstb = item.Nstb;
            this.Cnhc = item.Cnhc;
            this.Cntc = item.Cntc;

            this.HanghoaTPId = item.HanghoaTPId;
            this.DatHangId = item.DatHangId;
            this.DatHangCtId = item.DatHangCtId;
            this.RdQtsxGiaiDoanId = item.RdQtsxGiaiDoanId;
            this.NgaySanXuat = item.NgaySanXuat;
            this.FlagHead = item.FlagHead;
            this.FlagPassKhan = item.FlagPassKhan;
            this.FlagBTP = item.FlagBTP;
            this.FlagNPL = item.FlagNPL;
            this.messageBTP = item.messageBTP;
        }
    }
  
    export class KhKeHoachSanXuatLsThaoTacInteraction extends BaseModel{
        Id: number;
        KeHoachSanXuatId: number;
        NguoiThaoTac: number;
        TenNguoiThaoTac: string;
        NgayThaoTac: string;
        LoaiThaoTac: string;
        NoiDung: string;
        GhiChu: string;

        clear(){
            this.Id = 0;
            this.KeHoachSanXuatId = 0;
            this.NguoiThaoTac = 0;
            this.TenNguoiThaoTac = '';
            this.NgayThaoTac = '';
            this.LoaiThaoTac = '';
            this.NoiDung = '';
            this.GhiChu = '';
        }

        copy(item: KhKeHoachSanXuatLsThaoTacInteraction){
            this.Id = item.Id;
            this.KeHoachSanXuatId = item.KeHoachSanXuatId;
            this.NguoiThaoTac = item.NguoiThaoTac;
            this.TenNguoiThaoTac = item.TenNguoiThaoTac;
            this.NgayThaoTac = item.NgayThaoTac;
            this.LoaiThaoTac = item.LoaiThaoTac;
            this.NoiDung = item.NoiDung;
            this.GhiChu = item.GhiChu;
        }
    }

    export class GDSX extends BaseModel{
        Id: number
        Ten: string

        clear(){
            this.Id = 0;
            this.Ten = '';
        }

        copy(item: GDSX){
            this.Id = item.Id;
            this.Ten = item.Ten;
        }
    }

    export class DataWeek extends BaseModel{
        date: string 
        nameDate: string

        clear(){
            this.date = '';
            this.nameDate = '';
        }

        copy(item: DataWeek){
            this.date = item.date;
            this.nameDate = item.nameDate;
        }
    }

    export class NotificeDataKHSXTuan extends BaseModel{
        DataKHSX: KhKeHoachSanXuatInteraction 
        DataWeek: DataWeek[]

        clear(){
            this.DataKHSX = new KhKeHoachSanXuatInteraction();
            this.DataKHSX.clear();
            this.DataWeek = [];
        }

        copy(item: NotificeDataKHSXTuan){
            this.DataKHSX = item.DataKHSX;
            this.DataWeek = item.DataWeek;
        }
    }

    export class KeHoachSanXuatTheoTuan extends BaseModel{
        dataTuan: KeHoachSanXuatTuan
        ListItem: KhKeHoachSanXuatInteraction[]

        clear(){
            this.dataTuan = new KeHoachSanXuatTuan()
            this.ListItem = [];
        }
        copy(item: KeHoachSanXuatTheoTuan){
            this.dataTuan = item.dataTuan;
            this.ListItem = item.ListItem;
        }
    }

    export class KeHoachSanXuatTuanCopy extends BaseModel{
        idKhuVuc: number
        listDate: string[]

        clear(){
            this.idKhuVuc = 0;
            this.listDate = [];
        }
        copy(item: KeHoachSanXuatTuanCopy){
            this.idKhuVuc = item.idKhuVuc;
            this.listDate = item.listDate;
        }
    }

    export class ThongTinThietBi extends BaseModel{
        Id: number
        DinhMuc: number

        clear(){
            this.Id = 0;
            this.DinhMuc = 0;
        }

        copy(item: ThongTinThietBi){
            this.Id = item.Id;
            this.DinhMuc = item.DinhMuc;
        }
    }

    export class ThongTinKeHoachXacNhanPO extends BaseModel{
        IdKHXN: number
        SoLuong: number
        TenDVT: string
        NgayDeNghi: string

        clear(){
            this.IdKHXN = 0;
            this.SoLuong = 0;
            this.TenDVT = '';
            this.NgayDeNghi = '';
        }

        copy(item: ThongTinKeHoachXacNhanPO){
            this.IdKHXN = item.IdKHXN;
            this.SoLuong = item.SoLuong;
            this.TenDVT = item.TenDVT;
            this.NgayDeNghi = item.NgayDeNghi;
        }
    }

    export class TonKhoHienTai extends BaseModel {
       
        IdTk : number
        IdKho: number
        TenKho: string
        MaKho: string
        IdHh: number
        TenHH: string
        MaHH: string
        Solo: string
        Soluong: string
        Sopo: string
        Tinhtrang: boolean
        Ghichu: string
        Dvt: number
        TenDVT: string
        ViTriKho: string
        IdLo: number
        SoMay: string
        KD_DatHang_Ct_Id: number
        LyDoKhongDuocXuat: string
        FlagHead: boolean
        clear() {
            this.IdTk = 0;
            this.IdKho = 0;
            this.TenKho = '';
            this.MaKho = '';
            this.IdHh = 0;
            this.TenHH = '';
            this.MaHH = '';
            this.Solo = '';
            this.Soluong = '';
            this.Sopo = '';
            this.Tinhtrang = true;
            this.Ghichu = '';
            this.Dvt = 0;
            this.TenDVT = '';
            this.ViTriKho='';
            this.IdLo=0;
            this.SoMay = '';
            this.KD_DatHang_Ct_Id = 0;
            this.LyDoKhongDuocXuat = '';
            this.FlagHead = false;
        }
        copy(item:TonKhoHienTai){
            this.IdTk = item.IdTk;
            this.IdKho = item.IdKho;
            this.TenKho = item.TenKho;
            this.MaKho = item.MaKho;
            this.IdHh = item.IdHh;
            this.TenHH = item.TenHH;
            this.MaHH = item.MaHH;
            this.Solo = item.Solo;
            this.Soluong = item.Soluong;
            this.Sopo = item.Sopo;
            this.Tinhtrang = item.Tinhtrang;
            this.Ghichu = item.Ghichu;
            this.Dvt = item.Dvt;
            this.TenDVT = item.TenDVT;
            this.ViTriKho= item.ViTriKho;
            this.IdLo= item.IdLo;
            this.SoMay = item.SoMay;
            this.KD_DatHang_Ct_Id = item.KD_DatHang_Ct_Id;
            this.LyDoKhongDuocXuat = item.LyDoKhongDuocXuat;
            this.FlagHead = item.FlagHead;
        }
    }
